// extracted by mini-css-extract-plugin
module.exports = {"root":"Small_root__38ZeM","upload":"Small_upload__qNZJ0","imageWrap":"Small_imageWrap__1TlOM","removeBtn":"Small_removeBtn__9HEId"};